const page = require('page')
const request = require('superagent')
const inject = require('injectinto')

const get = key => JSON.parse(localStorage.getItem(key)) ?? null
const set = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
  return value
}

module.exports = (hub, scene) => {
  hub.every('start the ball rolling', (p, cb) => {
    if (scene.params().signup == null) scene.params().signup = {}
    const signup = scene.params().signup
    if (p.email != null) signup.email = p.email
    if (p.name != null) signup.name = p.name
    if (p.organisation != null) signup.organisation = p.organisation
    if (p.industry != null) signup.industry = p.industry
    if (signup.email != null && signup.name != null && signup.organisation != null && signup.industry != null) {
      request
        .post('/signup')
        .send(signup)
        .end((err, res) => {
          if (err != null) return alert(err)
          if (!res.ok) return alert(res.text)
          scene.params().page = 'signup'
          scene.update()
        })
    } else {
      scene.params().page = 'signup'
      scene.update()
    }
    cb()
  })
  hub.every('fire all cannons', (p, cb) => {
    request
      .post('/contact')
      .send(p)
      .end((err, res) => {
        if (err != null) return alert(err)
        if (!res.ok) return alert(res.text)
        page('/contact/thankyou')
      })
    cb()
  })
  hub.every('login', (p, cb) => {
    request
      .post('/login')
      .send(p)
      .end((err, res) => {
        if (err != null) return alert(err)
        if (!res.ok) return alert(res.text)

        const { sso, email } = JSON.parse(res.text)
        // If we are not doing a special login, proceed to classic login process
        if (!sso) {
          scene.params().page = 'login:pending'
          return scene.update()
        }
        const { type } = sso

        page(`/sso/${type}?email=${email}`)
      })
    cb()
  })
  hub.every('test azure auth', (p, cb) =>
    inject.one('query superagent')(request.post('/azure-ad/test').send({}), (err, res) =>
      err ? console.error(err) : console.log('Response:', res.body)
    )
  )
  hub.every('logout', (p, cb) => {
    if (get('authtype') == 'azure-ad') {
      localStorage.removeItem('authtype')
      localStorage.removeItem('account')
      localStorage.removeItem('emaildomain')
      localStorage.removeItem('AD_CLIENT_ID')
      localStorage.removeItem('AD_AUTHORITY')
      localStorage.removeItem('AD_TENANT_ID')
    }
    return (window.location = '/logout')
  })
}
